import * as React from "react"
import { batch } from "@preact/signals-react"
import { DrawerSeeker } from "@ui-seeker/core"

import AdminNewListedFormDrawerContent from "./Content"
import { useAdminNewListedForm } from "../@hooks"
import { adminNewListedFormIsOpen, adminNewListedFormTitle, adminNewListedFormRowData } from "../@signals"


export default function AdminNewListedFormDrawer() {
	const { handleUpdate } = useAdminNewListedForm()

    return <DrawerSeeker
		isOpen={adminNewListedFormIsOpen.value}
		controller={() => batch(() => {
			adminNewListedFormTitle.value = null
			adminNewListedFormRowData.value = {}
		})}
		title={`EDIT ${adminNewListedFormTitle.value}`}
		width="40%"
		successProps={{ onClick: handleUpdate }}
	>
    	<AdminNewListedFormDrawerContent />
    </DrawerSeeker>
}